import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var chooseImage = normalize.chooseImage(function (args) {
  return swan.chooseImage(args);
}, CONTAINER_NAME.BAIDU);
export default chooseImage;